import { useMemo } from "react";

import { ICatalogueCustomizationsOptions } from "../../../../apis/useGetCatalogueData/types";
import { IPricedAccordionSelection } from "../setitems/types";
import CustomizationOptionDisplay from "./CustomizationOptionDisplay";

export const useCustomizationOptionsSelections = (options: ICatalogueCustomizationsOptions[]) => {
	const selections = useMemo((): IPricedAccordionSelection[] => {
		return options.map(({ id, title, title_cn, price }) => ({
			id,
			selection_display: (
				<CustomizationOptionDisplay title={title} title_cn={title_cn} price={price} />
			),
			selected_display: (
				<CustomizationOptionDisplay title={title} title_cn={title_cn} price={price} />
			),
			price_diff: price,
		}));
	}, [options]);

	return {
		selections,
	};
};
